import * as fieldset from './fieldset';

export default {
  title: 'Create Membership Checkout',
  elements: [
    {
      type: 'createForm',
      config: {
        actions: {
          save: {
            endpoint: 'membership-checkouts',
            method: 'POST'
          }
        },
        fieldsets: [fieldset.main]
      }
    }
  ]
};
